import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, filter, first, map } from 'rxjs';
import { ReturnViewModel } from '../interfaces/viewmodels/returnViewModel';
import { EmployeeAccessViewModel, PermissionViewModel, NWAModel, UserViewModel } from '../interfaces/viewmodels/userviewmodel';

declare var CURRENT_USER_DISPLAYNAME: string;
declare var CURRENT_USER_ID: number;
declare var CURRENT_USER_LOGINID: string;
declare var HART_API: string;
declare var COMMON_API: string;
declare var RTA_API: string;
@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }
  public UserPermissions: any[] = [];
  public Busy: Boolean = false;
  public windowmarginreport: any;
  public DashboardMainComponent: any;
  ngOnInit(): void {
  }

  public GridLaoded: boolean = false;
  public AuditMessage: string = "";
  UserSettingsDataRetrieved: any;
  DisplayName: string = CURRENT_USER_DISPLAYNAME;
  CURRENT_USER_ID: number = CURRENT_USER_ID;
  CURRENT_USER_LOGINID: string = CURRENT_USER_LOGINID;
  COMMON_API: string = COMMON_API;
  update: boolean = false;


  getAccessByEmployee(userId: string) {
    return this.http.get<EmployeeAccessViewModel>(`${COMMON_API}/Administrator/GetEmployeeAccess?UserId=${userId}`);
  }
  getPermissions() {
    return this.http.get<PermissionViewModel>(`${COMMON_API}/Permissions()?$filter=substringof('HART',Name)`);
  }
  getEmployeeBySearch(searchKey: string) {
    return this.http.get<any[]>(`${COMMON_API}/Users()?$filter=substringof('${searchKey}',DisplayName) or substringof('${searchKey}',LoginID)`);
  }
  getCurrentUserNWAs(): Observable<NWAModel[]> {
    return this.http.get<{ 'odata.metadata': string, value: any[] }>(`${COMMON_API}/UserNWA()?$filter=LoginID eq '${CURRENT_USER_LOGINID}'`).pipe(map(response => response.value));
  }
  getEmployees() {
    return this.http.get<any[]>(`${COMMON_API}/Users()`);
  }
  getCurrentUser(): Observable<UserViewModel> {
    return this.http.get<ReturnViewModel>(`${COMMON_API}/User('${CURRENT_USER_LOGINID}')`).pipe(
      map(response => response.info as UserViewModel)
    );
  }
  RetrieveUserPermissionsRetrieved: boolean = false;
  public RetrievePermissionsCompleted: EventEmitter<any> = new EventEmitter();

  /** Observable that emits true once permissions have been fully loaded. */
  private _permissionsReady$ = new BehaviorSubject<boolean>(false);
  public permissionsReady$: Observable<boolean> = this._permissionsReady$.asObservable();

  /** Call this once permissions have been set on the service. */
  markPermissionsReady(): void {
    this.RetrieveUserPermissionsRetrieved = true;
    this._permissionsReady$.next(true);
    this.RetrievePermissionsCompleted.emit();
  }

  /**
   * Returns a promise that resolves when permissions are loaded.
   * If already loaded, resolves immediately.
   */
  whenReady(): Promise<boolean> {
    return this.permissionsReady$.pipe(
      filter(ready => ready),
      first()
    ).toPromise().then(() => true);
  }

  CheckPermission(permission: string): boolean {
    let permissiongranted = this.UserPermissions.filter(r => (r.Name ?? r.name) == permission).length > 0;
    return this.RetrieveUserPermissionsRetrieved && permissiongranted;
  }
}
